<template>
  <v-icon
    color="#D4CECD"
    :loading="loading"
    :disabled="disabled"
    @click="save"
  >
    add
  </v-icon>
</template>

<script>
import { createPaymentPrivat24 } from "../../../backend/paymentsApi";

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    disabled(){
      return this.value.transactionType === "D" || this.isDisabled;
    },
  },
  methods: {
    async save() {
      this.loading = true;
      await createPaymentPrivat24({
        id: this.value.transactionId,
        date: this.value.transactionDateTime,
        amount: +this.value.amount,
        reason: this.value.reasonForPayment,
        payerCode: this.value.contractPartnerUSREOU,
        payerName: this.value.contractPartnerName,
      });
      this.loading = false;
    },
  },
};
</script>
